import React from "react";
import Paragraphs from "components/Paragraphs";

export default function ParagraphDisclosures({ data, level }) {
  return (
    <div className="mx-auto lg:max-w-screen-lg">
      {data.field_title && (
        <h2 className="mb-8 font-important text-4xl">{data.field_title}</h2>
      )}
      <Paragraphs paragraphs={data.field_paragraphs} level={level + 1} />
    </div>
  );
}
